import * as React from 'react';
import  './event.scss';
import Moment from "react-moment";
import { getId } from 'office-ui-fabric-react/lib/Utilities';
export interface IProps{
    phrases;
    GetCRMdataforrecent;
    PrepareContactCRMReportUI;
    PrepareContactCRMSSOUI;
}
export default class ContactCRMRecents extends React.Component<IProps>{
    public state ={loading:true,currentview:'notes'};
    public crmdata=null;
    public apiinvoked=false;
    constructor(props) {
        super(props);
        if(this.crmdata==null && this.apiinvoked==false){
            this.apiinvoked=true;
            this.LoadCRMData();
        }
      }
    public render() {
        
        return (
            <div style={{padding:"0px 15px"}}>
                {this.state.loading?(
                     <div style={{margin:'o auto'}} className="mipaloading">&nbsp;</div>
                ):(
                    <div className="outlookeventassignecontainer">
                    <span  onClick={()=>{this.changeviw("notes");}} className={this.state.currentview=='notes'?"attendeetype typeselected":"attendeetype"}>{this.props.phrases.desctrictioncaption}</span>
                    <span  onClick={()=>{this.changeviw("meetings");}} className={this.state.currentview=='meetings'?"attendeetype typeselected":"attendeetype"}>{this.props.phrases.meetingreport}</span>
                    <span onClick={()=>{this.changeviw("sso");}} className={this.state.currentview=='sso'?"attendeetype typeselected":"attendeetype"}>{this.props.phrases.opportunity}</span>
                    
                    <div className={this.state.currentview=='notes'?"attendeelist attendeelistactive":"attendeelist"}>
                        {this.preparenotethumbs()}
                        <div className="clear">&nbsp;</div>
                    </div>
                    <div className={this.state.currentview=='meetings'?"attendeelist attendeelistactive":"attendeelist"}>
                        {this.props.PrepareContactCRMReportUI(this.crmdata.Meetings)}
                        <div className="clear">&nbsp;</div>
                    </div>
                    <div className={this.state.currentview=='sso'?"attendeelist attendeelistactive":"attendeelist"}>
                        {this.props.PrepareContactCRMSSOUI(this.crmdata.SSOList)}
                        <div className="clear">&nbsp;</div>
                    </div>
                    
          </div>
          
                )}
                
            </div>
        
        );
    }
    private changeviw=(newview)=>{
        if(this.state.currentview!=newview){
            this.setState({currentview:newview});
        }
    }
    private LoadCRMData=()=>{
        let fnsuccess=(response)=>{
            if (response.data.IsSucess && response.data.ReturnJsonString != ""){
                this.crmdata=JSON.parse(response.data.ReturnJsonString);
                this.setState({loading:false});
                //console.log(this.crmdata);
            } else {
                this.crmdata={};
            }
            
        }
        this.props.GetCRMdataforrecent(fnsuccess);
    }
    private preparenotethumbs=()=>{
        
        let noteuilist=[];
        let keyval=getId("note");
        this.crmdata.Notes.forEach(element => {
            keyval="Recntnote_"+element.Id;
            noteuilist.push(
                <div className="notethumbitem" key={keyval} >         
                    <div className="ms-Grid-row thumbrow thumbheader">             
                        <div className="ms-Grid-col ms-sm12 noteicon1 backgroundIcon1">
                            <Moment format="DD MMM YYYY">
                                {element.notedate}
                            </Moment> 
                           <a href={element.editlink} target="_blank">
                                <i className="ms-Icon ms-Icon--Edit ponter righticon" />
                           </a> 
                        </div>         
                    </div>
                    <div className="ms-Grid-row thumbrow" title={element.subject}>             
                        <div className="ms-Grid-col ms-sm12">                 
                            <div className="texteclips">{element.subject}</div>  
                        </div>
                    </div>         
                    <div className="ms-Grid-row thumbrow">          
                       <div className="ms-Grid-col ms-sm12">   
                            <div className="texteclips" title={element.summary}>{element.summary}</div>                
                       </div>             
                    </div>             
                    <div className="ms-Grid-row thumbrow">             
                        <div className="ms-Grid-col ms-sm12"> 
                            <div className="texteclips">Category : {element.category}</div>
                        </div>         
                    </div>         
                    <div className="ms-Grid-row thumbrow thmubfooter">             
                        <div className="ms-Grid-col ms-sm12 summaryedit">   
                        &nbsp;             
                        </div>             
                    </div>          
                </div> 
            );
        });
        return noteuilist;
    }
}